import useTracksStore, {
  SOUND_DESIGN_TRACK_ID,
  TrackType,
} from '../../../../../shared/store/tracks.store.tsx'
import useMediaStore from '../../../../../shared/store/media.store.tsx'
import { getAudioBufferFromAudioUrl } from '@/utils/get-audio-buffer-from-audio-url.ts'
import type {
  AudioFormArrangement,
  AudioFormSection,
  SoundDesignAsset,
} from '../../../../audio-form/data/dto/audio-form-input.ts'
import { reduceAudioBufferVolume } from '@/utils/reduce-audiobuffer-volume.ts'

export const mapSoundDesignSectionToClip = async (
  asset: SoundDesignAsset,
  section: AudioFormSection,
  arrangement: AudioFormArrangement
): Promise<void> => {
  // Load asset into media store
  const { addMedia } = useMediaStore.getState()
  // todo: make this required
  if (!section.soundTemplateUri) return

  const originalAudioBuffer = await getAudioBufferFromAudioUrl(
    section.soundTemplateUri
  )
  const audioBuffer = reduceAudioBufferVolume(originalAudioBuffer)
  // Cropped Instant Creative renders must not use the template alias as the media
  // key — that key is reserved for full-length library / generated audio.
  const mediaId = section.soundTemplateUri
  addMedia(mediaId, audioBuffer)

  // Load clip into tracks store
  const { addClip } = useTracksStore.getState()

  const paddingEnd = audioBuffer.duration - (section.duration ?? 0) // todo: make this required

  addClip(SOUND_DESIGN_TRACK_ID, {
    id: asset.soundTemplateAlias,
    type: TrackType.SoundDesigns,
    trackId: SOUND_DESIGN_TRACK_ID,
    name: asset.soundTemplateAlias.replace(/_/g, ' '),
    mediaId,
    src: section.soundTemplateUri,
    startAt: section.position ?? 0,
    startOffset: 0,
    endOffset: paddingEnd ? -paddingEnd : 0,
    duration: audioBuffer.duration,
    fadeIn: arrangement.fadeIn ?? 0,
    fadeOut: arrangement.fadeOut ?? 0,
  })
}
